@if (isLoading) {
  <div class="loader-overlay" role="status" aria-live="polite">
    <div class="heart-wrapper" aria-hidden="true">
      <svg class="heart-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          class="heart-shape"
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4 8.24 4 9.91 5 10.54 6.36
               11.17 5 12.76 4 14.5 4 17 4 19 6 19 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        />
        <polyline class="ekg" points="3 12 7 12 9 8 11 15 13 6 15 12 21 12" fill="none" />
      </svg>
    </div>
    <p class="loader-text mt-3 fw-semibold text-dark">Verifying code...</p>
  </div>
}

@if (!isLoading) {
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-5">
        <div class="card booking-card auth-card">
          <div
            class="card-header booking-card__header text-center justify-content-center flex-column pb-3"
          >
            <div class="booking-card__eyebrow">Two-Factor Authentication</div>
            <h2 class="sub-title mb-0 fs-3">Verify Your Identity</h2>
          </div>

          <div class="card-body p-4">
            <!-- Prominent Error Alert Banner -->
            @if (errorMessage) {
              <div
                class="alert alert-danger d-flex align-items-start mb-4 p-3 rounded-3 shadow-sm border-danger border-start border-4"
                role="alert"
              >
                <i
                  class="bi bi-exclamation-octagon-fill fs-4 me-3 text-danger flex-shrink-0 mt-1"
                ></i>
                <div class="flex-grow-1">
                  <div class="fw-bold text-danger">Verification Failed</div>
                  <div class="small text-dark mt-1">{{ errorMessage }}</div>
                </div>
                <button
                  type="button"
                  class="btn-close ms-2"
                  (click)="errorMessage = null"
                  aria-label="Close error message"
                ></button>
              </div>
            }

            <div class="text-center mb-4">
              <p class="text-muted small mb-1">
                We've sent a one-time verification code to your email address:
              </p>
              <span
                class="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill px-3 py-1 fw-bold"
              >
                {{ maskedEmail }}
              </span>
            </div>

            <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()" novalidate>
              <!-- OTP Input -->
              <div class="mb-4">
                <label for="otp" class="form-label text-center d-block"
                  >Enter Verification Code</label
                >
                <input
                  id="otp"
                  type="text"
                  maxlength="5"
                  class="form-control text-center fs-3 fw-bold letter-spacing"
                  formControlName="otp"
                  placeholder="00000"
                  autocomplete="one-time-code"
                />

                @if (
                  otpForm.controls['otp'].touched && otpForm.controls['otp'].errors?.['required']
                ) {
                  <div class="text-danger small mt-1 text-center">
                    Verification code is required.
                  </div>
                }
                @if (
                  otpForm.controls['otp'].touched && otpForm.controls['otp'].errors?.['minlength']
                ) {
                  <div class="text-danger small mt-1 text-center">Enter the complete code.</div>
                }
                @if (
                  otpForm.controls['otp'].touched && otpForm.controls['otp'].errors?.['pattern']
                ) {
                  <div class="text-danger small mt-1 text-center">Numbers only.</div>
                }
              </div>

              <!-- Verify Button -->
              <div class="d-grid mb-3">
                <button type="submit" class="btn btn-primary py-2" [disabled]="otpForm.invalid">
                  <i class="bi bi-shield-check me-1"></i> Verify and Continue
                </button>
              </div>

              <!-- Resend OTP -->
              <div class="text-center">
                <small class="text-muted">Didn't receive the code?</small>
                <button
                  type="button"
                  class="btn btn-link text-primary text-decoration-none p-0 ms-1 fw-semibold small"
                  (click)="resendOtp()"
                  [disabled]="resendCountdown > 0"
                >
                  @if (resendCountdown > 0) {
                    Resend in {{ resendCountdown }}s
                  } @else {
                    Resend Code
                  }
                </button>
              </div>

              <!-- Back -->
              <div class="text-center mt-4 pt-2 border-top">
                <a routerLink="/" class="small text-muted text-decoration-none">
                  <i class="bi bi-arrow-left me-1"></i> Back to Login
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
}
